export default __webpack_public_path__ + "barcode.f0492ba89a56733fc0972a06f6d9cc84.svg";